module.exports = __webpack_public_path__ + "static/anana-vestige-journal-video-cover-c2abb61081f723eee649ede7e7c773e1.png";